/** Convert a File or Blob to a base64 data URL (survives page refresh). */
export const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

/** Normalize API base64 strings to data URLs. */
export const ensureDataUrl = (value, mime = "image/png") => {
  if (!value || typeof value !== "string") return "";
  if (value.startsWith("data:")) return value;
  if (value.startsWith("blob:") || value.startsWith("http")) return value;
  return `data:${mime};base64,${value}`;
};

/** Convert blob/http/data URL to a persistable data URL. */
export const urlToDataUrl = async (url) => {
  if (!url || typeof url !== "string") return "";
  if (url.startsWith("data:")) return url;

  try {
    const res = await fetch(url);
    const blob = await res.blob();
    return await fileToDataUrl(blob);
  } catch (error) {
    console.warn("Could not convert image to data URL:", url, error);
    return "";
  }
};

export const urlsToDataUrls = async (urls) => {
  if (!Array.isArray(urls) || urls.length === 0) return [];
  const converted = await Promise.all(urls.map(urlToDataUrl));
  return converted.filter(Boolean);
};

export const getRestoredUploadedImages = (formData) => {
  const persisted = formData?.uploadedImagesBase64;
  if (Array.isArray(persisted) && persisted.length > 0) {
    return persisted.filter((u) => u && u.startsWith("data:"));
  }

  const uploaded = formData?.uploadedImages || [];
  return uploaded.filter(
    (u) =>
      u &&
      (u.startsWith("data:") ||
        u.startsWith("http://") ||
        u.startsWith("https://")),
  );
};

export const getRestoredProcessedImages = (persistedState) => {
  const topLevel = persistedState?.processedImages;
  if (Array.isArray(topLevel) && topLevel.length > 0) {
    return topLevel.filter((u) => u && u.startsWith("data:"));
  }

  const nested = persistedState?.formData?.processedImagesBase64;
  if (Array.isArray(nested) && nested.length > 0) {
    return nested.filter((u) => u && u.startsWith("data:"));
  }

  return [];
};
